"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoidLogger = void 0;
class VoidLogger {
    debug() { }
    log() { }
    error() { }
    warn() { }
    info() { }
}
exports.VoidLogger = VoidLogger;
//# sourceMappingURL=VoidLogger.js.map